import { Injectable } from "@angular/core";
import { ApiService } from "../global.service";
import { Observable } from "rxjs";
import { HttpBackend, HttpClient } from "@angular/common/http";

import { environment } from '../../../environments/environment';
import { Payment } from "./payment.interface";
import { ConfigService } from "../config.service";
import { LocalStorageService } from "../storage.service";
import { BusinessContextService } from "../business-context.service";


// const URL = environment.URL;
// const CUSTOMER = environment.CUSTOMER;

@Injectable({
    providedIn: 'root'
})
export class PaymentService extends ApiService {
    constructor(
        public override http: HttpClient,
        public override config: ConfigService,
        public override localStorageService: LocalStorageService,
        handler: HttpBackend,
        private bizCtx: BusinessContextService,
    ) {
        super(http, config, localStorageService, handler);
    }

    private getBusiness(): string { return this.bizCtx.getSelected() || this.CUSTOMER; }

    getPayment(paymentHashId: string): Observable<Payment[]> {
        const business = this.getBusiness();
        return this.get<Payment[]>(`${this.URL}/payment/${business}/${paymentHashId}`);
    }

    getPayments(): Observable<Payment[]> {
        const business = this.getBusiness();
        return this.get<Payment[]>(`${this.URL}/payment/${business}`);
    }

    createPayment(payment: Payment): Observable<Payment> {
        console.log({ payment });
        const business = this.getBusiness();
        return this.create<Payment>(`${this.URL}/payment/${business}`, payment);
    }
}

